import Button from "../Shared/Button"
import Input from "../Shared/Input"
import WhiteLogo from "../../assets/WhiteLogo.svg"
import Pattern from "../../assets/ContactUsCard.svg"
import TextArea from "../Shared/TextArea"
import { useMutation } from "@tanstack/react-query"
import { SendContactUs } from "../../api/Emails/SendContactUs"
import { toast } from "react-toastify"
import { useFormik } from "formik"
import * as Yup from "yup"
import { ButtonTypes } from "../../utils/consts"
import { AxiosError } from "axios"

const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    message: Yup.string().required("Message is required"),
});

const ContactUsSection = () => {
    const { mutate, error, isPending } = useMutation({
        mutationFn: SendContactUs,
        onSuccess: () => {
            toast.success("Email sent successfully");
        },
    });
    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            message: "",
        },
        validationSchema,
        onSubmit: (values) => {
            mutate(values);
        },

    });

    return (
        <div id="contact-us" className="container md:mt-40 mt-28 pt-1">
            <div className="flex justify-center xl:gap-10 gap-8 w-full">
                <div className="lg:w-1/2 w-full">
                    <div className="sm:mb-10 mb-8">
                        <h1 className="sm:mb-5 mb-3 sm:text-2xl text-lg">
                            Contact Us<br />
                            with <span className="text-secondary font-bold sm:text-[28px] text-xl">Nile Wise</span>
                        </h1>
                        <p className="font-medium text-[#808080] tracking-[0.01em] sm:text-base text-sm">At NileWise, we’re here to help you succeed. Reach out to us for tailored solutions, expert guidance, or any inquiries—we’re just a message away!</p>
                    </div>
                    <form onSubmit={formik.handleSubmit} className="sm:space-y-5 space-y-3 w-full">
                        <Input placeholder="Name" name="name" className="w-full" inputStyles="!rounded-none sm:!h-12 !h-11" value={formik.values.name} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.name && formik.errors.name ? formik.errors.name : ""} />
                        <Input placeholder="Email" name="email" className="w-full" inputStyles="!rounded-none sm:!h-12 !h-11" value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.email && formik.errors.email ? formik.errors.email : ""} />
                        <Input placeholder="Phone Number" name="phone" className="w-full" inputStyles="!rounded-none sm:!h-12 !h-11" value={formik.values.phone} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.phone && formik.errors.phone ? formik.errors.phone : ""} />
                        <TextArea placeholder="Message" name="message" inputStyles="!h-[128px] !rounded-none border-2 border-black" value={formik.values.message} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.message && formik.errors.message ? formik.errors.message : ""} />
                        <Button
                            type={ButtonTypes.SUBMIT}
                            disabled={formik.isSubmitting || isPending}
                            variant="primary" className="w-full !rounded-none sm:!h-[55px] !h-12 sm:!text-base !text-sm" >Send
                            {isPending ? (
                                <svg
                                    aria-hidden="true"
                                    className="w-8 h-8 text-gray-200 ml-3 animate-spin inline dark:text-gray-600 fill-secondary"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                    />
                                </svg>
                            ) : (
                                ""
                            )}
                        </Button>
                        {error instanceof AxiosError && (
                            <span className="text-red-500 font-bold text-lg">
                                {error?.response?.data?.message || "An error occurred"}
                            </span>
                        )}

                    </form>
                </div>
                <div className="lg:block hidden  min-w-[430px] bg-[#c7461f] rounded-[30px] relative">
                    <img className="absolute w-full h-full" src={Pattern} alt="" />
                    <img src={WhiteLogo} className="absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-[320px]" alt="" />
                </div>
            </div>
        </div>
    )
}

export default ContactUsSection